import { Box, SxProps } from '@mui/material';
import { blue } from '@mui/material/colors';
import React, { ReactNode } from 'react';
import AppBar from '../app-bar/AppBar';
import background from '../assets/background.png';

export interface AccountLayoutProps {
  children: ReactNode;
  sx?: SxProps;
}

const AccountLayout = ({ children, sx = {} }: AccountLayoutProps) => (
  <>
    <AppBar />
    <Box
      sx={{
        background: `url(${background}) ${blue[50]} no-repeat 665px center`,
        minHeight: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 48px)' },
      }}
    >
      <Box
        sx={{
          px: { xs: 3, sm: 9 },
          display: 'flex',
          flexDirection: 'column',
          maxWidth: '600px',
          backgroundColor: 'background.default',
          textAlign: 'center',
          minHeight: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 48px)' },
          pb: 4.75,
          ...sx,
        }}
      >
        {children}
      </Box>
    </Box>
  </>
);

export default AccountLayout;
